import React from 'react';
import { VideoPlayer as VideoPlayerComponent } from '../common';



const VideoSection = () => {
  return (
    <div style={{ padding: '4rem 0', background: '#f5f5f5', textAlign: 'center' }}>
      <div style={{ maxWidth: '1200px', margin: '0 auto', padding: '0 1rem' }}>
        <h2 style={{ fontSize: '2.5rem', marginBottom: '1rem', color: '#01675f' }}>
          See How RPL Works
        </h2>
        <p style={{ fontSize: '1.1rem', marginBottom: '3rem', color: '#666', maxWidth: '600px', margin: '0 auto 3rem auto' }}>
          Watch our video to understand how Recognition of Prior Learning can transform your career and get you the qualifications you deserve.
        </p>
        
        <div style={{ maxWidth: '800px', margin: '0 auto' }}>
          <video 
            controls 
            width="100%" 
            style={{ borderRadius: '12px', boxShadow: '0 8px 32px rgba(0, 0, 0, 0.2)' }}
            onError={(e) => console.error('Video error:', e)}
            onLoadStart={() => console.log('Video loading started')}
            onCanPlay={() => console.log('Video can play')}
          >
            <source src="/video1.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        
        <p style={{ marginTop: '2rem', color: '#666', fontSize: '1rem', lineHeight: '1.6' }}>
          This video showcases the real experiences of professionals who have successfully completed their RPL journey with us. Learn about the process, benefits, and how you can get started on your own qualification pathway.
        </p>
      </div>
    </div>
  );
};

export default VideoSection; 